import { useSelector } from 'react-redux'

import { selectProjectIdentity } from '@store/actionSlices/projectIdentity'
import { selectWhiteLabel } from '@store/actionSlices/whiteLabel'

import mapWhiteLabelsWithDefaults from '@utilities/white-label'

import { getStatusColour } from './level-explorer-util'

const useLevelDisplayConfig = () => {
  const whiteLabel = useSelector(selectWhiteLabel)
  const { statusLabels, statusColors } = useSelector(selectProjectIdentity)

  const { levelStagePrefix } =
    mapWhiteLabelsWithDefaults(whiteLabel).showcase.propertySidePanel
  const availableStatusLabel = statusLabels?.available

  return {
    levelStagePrefix,
    availableStatusLabel,
    availableStatusColour: getStatusColour(statusColors, availableStatusLabel),
  }
}

export default useLevelDisplayConfig
